const Brands=[
    {
     IMG:'/Brands/alcon.png',   
    },
    {
        IMG:'/Brands/B+L.png',   
    },
    {
        IMG:'/Brands/levis.png',   
    },
    {
        IMG:'/Brands/BOSS.png',   
    },
    {
        IMG:'/Brands/Careera.png',   
    },
    {
        IMG:'/Brands/Coopervision.png',   
    },
    
    {
        IMG:'/Brands/CK.png',   
    },
    {
        IMG:'/Brands/D&G.png',   
    },
     {
        IMG:'/Brands/AX.png',   
    },
    {
        IMG:'/Brands/Disel.png',   
    },
    {
        IMG:'/Brands/EA.png',   
    },
    {
        IMG:'/Brands/Essilor.png',   
    },
    {
        IMG:'/Brands/Fastrack.png',   
    },
    {
       
    },
    {
        IMG:'/Brands/Hoya.png',   
    },
    {
        IMG:'/Brands/IDEE.JPEG',   
    },
    {
        IMG:'/Brands/Nike.png',   
    },
    {
        IMG:'/Brands/Kodak.png',      
    },
    {
        IMG:'/Brands/Nova.png',   
    },
    {
        IMG:'/Brands/RayBan.jpg',   
    },
    {
        IMG:'/Brands/oakley.png',   
    },
    {
        IMG:'/Brands/Prada.jpg',   
    },
    {
        IMG:'/Brands/Lacoste.png',   
    },
    {
        IMG:'/Brands/mk.png',   
    },
    {
        IMG:'/Brands/maui_jim.png',   
    },
    {
        IMG:'/Brands/montblanc.jpg',   
    },
    {
        IMG:'/Brands/nautica.png',   
    },
    {
        IMG:'/Brands/Pieere.jpg',   
    },
    {
        IMG:'/Brands/Polaroid.jpg',   
    },
    {
        IMG:'/Brands/Police.jpg',   
    },
    {
        IMG:'/Brands/Rodenstock.png',   
    },
    {
        IMG:'/Brands/Safilo.png',   
    },
    {
        IMG:'/Brands/Scott.jpg',   
    },
    {
        IMG:'/Brands/Silhoutte.png',   
    },
    {
        IMG:'/Brands/Sprint.png',   
    },
    {
        IMG:'/Brands/Superman.png',   
    },
    {
        IMG:'/Brands/Swaroski.png',   
    },
    {
        IMG:'/Brands/FC.jpg',   
    },
    {
        IMG:'/Brands/TommyHillfiger.png',   
    },
    {
        IMG:'/Brands/Nikon.png',   
    },
    {
        IMG:'/Brands/Titan.jpeg',   
    },
    {
        IMG:'/Brands/Transmit.jpg',   
    },
    {
        IMG:'/Brands/Vogue.png',   
    },
    {
        IMG:'/Brands/Batman.png',   
    },
    {
        IMG:'/Brands/J&J.png',   
    },
    {
        IMG:'/Brands/Zeiss.jpg',   
    },
]

    export default Brands;